export var SET_ACCORDION_ITEM = 'SET_ACCORDION_ITEM';
export var SHOW_ACCORDION_ITEM = 'SHOW_ACCORDION_ITEM';
export var SET_ACCORDION_DESCRIPTION = 'SET_ACCORDION_DESCRIPTION';